import { sharedAr } from '@cold-ambulance/ui';

const ar = {
  ...sharedAr,
  common: {
    save: 'حفظ',
    saving: 'جارٍ الحفظ...',
    cancel: 'إلغاء',
    next: 'التالي',
    back: 'رجوع',
    email: 'البريد الإلكتروني',
    password: 'كلمة السر',
    confirm: 'تأكيد',
    send: 'إرسال',
    processing: 'جاري المعالجة...',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    viewAll: 'عرض الكل',
    signIn: 'تسجيل الدخول',
    viewDetails: 'عرض التفاصيل',
  },
  nav: {
    dashboard: 'لوحة التحكم',
    requests: 'الطلبات',
    sentOffers: 'العروض المرسلة',
    profile: 'الملف الشخصي',
  },
  header: {
    welcome: 'مرحبًا بك',
    profileData: 'بيانات الملف الشخصي',
    logout: 'تسجيل الخروج',
    notifications: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات جديدة',
    companyLogo: 'شعار الشركة',
  },
  home: {
    inProgressRequests: 'طلبات قيد التنفيذ',
    currentTasks: 'المهام التي تعمل عليها حاليًا',
    latestRequests: 'آخر الطلبات',
    noCurrentRequests: 'لا يوجد طلبات حاليًا',
    noRequestsReceived: 'لم يتم استلام أي طلبات حتى الآن',
    noInProgressRequests: 'لا يوجد طلبات قيد التنفيذ حاليًا',
    documentsRejected: 'مستندات مرفوضة - يرجى إعادة الرفع',
    offerAwaitingDocs: 'لديك عرض بانتظار رفع المستندات',
    project: 'مشروع: {{name}}',
    reason: 'السبب: {{reason}}',
    documentsUploaded: '{{uploaded}} من {{total}} مستندات مرفوعة',
    reUpload: 'إعادة الرفع',
    uploadDocuments: 'رفع المستندات',
    defaultProject: 'مشروع',
  },
  signin: {
    title: 'تسجيل الدخول كمزود خدمة',
    noAccount: 'ليس لديك حساب بعد؟',
    registerWithUs: 'سجل معنا',
    forgotPassword: 'نسيت كلمة المرور؟',
    signingIn: 'جاري التسجيل...',
  },
  signup: {
    registerWithUs: 'سجل معنا',
    haveAccount: 'لديك حساب؟',
    stepTitle: 'البيانات التفصيلية',
    creatingAccount: 'جارٍ إنشاء الحساب...',
    continuing: 'جارٍ المتابعة...',
    contactPerson: 'جهة الاتصال',
    requiredDocuments: 'الوثائق المطلوبة',
    phoneInUse: 'رقم الجوال مستخدم.',
    confirmPassword: 'تأكيد كلمة السر',
    termsAccept: 'أوافق على الشروط والأحكام',
    termsAcceptPrefix: 'أوافق على',
    termsAnd: 'و',
    privacyPolicy: 'سياسة الاستخدام والخصوصية',
    vendorAgreement: 'اتفاقية اشتراك مزود الخدمة في المنصة',
  },
  profile: {
    title: 'بيانات الملف الشخصي',
    generalInfo: 'معلومات عامة',
    contactInfo: 'معلومات جهة الاتصال',
    requiredDocs: 'الوثائق المطلوبة',
    serviceProviderName: 'اسم مقدم الخدمة',
    phoneNumber: 'رقم الجوال',
    firstName: 'الاسم الأول',
    lastName: 'اسم الأخير',
    contactJobTitle: 'المسمى الوظيفي لجهة الاتصال',
    bankCertificate: 'الشهادة البنكية',
    commercialRegistration: 'السجل التجاري',
    taxCertificate: 'الشهادة الضريبية',
    zakatCertificate: 'شهادة التسجيل في هيئة الزكاة والضرائب',
    companyLogo: 'شعار الشركة',
    redCrescentCertificate: 'شهادة امتثال من الهلال الأحمر',
    nationalAddressCertificate: 'شهادة العنوان الوطني',
  },
  placeholders: {
    companyName: 'شركة الرواد الطبية',
    firstName: 'مشاري',
    lastName: 'العنزي',
    projectManager: 'مدير المشاريع',
    enterFullName: 'أدخل اسمك الكامل',
    executiveDirector: 'مثال: المدير التنفيذي',
    writeRejectionReason: 'اكتب سبب رفض الحوالة...',
  },
  requests: {
    allRequests: 'جميع الطلبات',
    requestDetails: 'تفاصيل الطلب',
    inProgress: 'قيد التنفيذ: {{name}}',
    proposalDeadline: 'الموعد النهائي للتقديم: {{date}}',
    bankGuarantee: 'ضمان {{percent}}%',
  },
  services: {
    ambulance: 'سيارة إسعاف',
    equipment: 'معدة',
    paramedic: 'مسعف',
    nurse: 'ممرض',
    doctor: 'طبيب',
    paramedicSpecialist: 'فني مسعف - أخصائي',
    paramedicTechnician: 'فني مسعف - فني',
    nurseSpecialist: 'ممرض - أخصائي',
    nurseTechnician: 'ممرض - فني',
    doctorWithSpec: 'طبيب - {{specialization}}',
    ambulanceWithDriver: 'سيارة إسعاف مع سائق - {{type}}',
    ambulanceWithoutDriver: 'سيارة إسعاف بدون سائق - {{type}}',
    ambulance4x4WithDriver: 'سيارة إسعاف 4x4 مع سائق',
    ambulance4x4WithoutDriver: 'سيارة إسعاف 4x4 بدون سائق',
    mobileClinic: 'عيادة متنقلة',
    mobileClinicBasic: 'عيادة متنقلة أساسية',
    mobileClinicAdvanced: 'عيادة متنقلة متقدمة',
    specialist: 'أخصائي',
    technician: 'فني',
  },
  offers: {
    sentOffers: 'العروض المرسلة',
    statusLabel: 'الحالة: {{status}}',
    all: 'الكل',
    accepted: 'مقبول',
    rejected: 'مرفوض',
    pending: 'قيد المناقشة',
    inProgress: 'قيد التنفيذ',
    notSelected: 'غير مختار',
    canceled: 'ملغي',
    filterResults: 'تصفية النتائج',
    offeredPrice: 'السعر المقدم',
    status: 'الحالة',
    submittedOn: 'تم تقديم العرض يوم',
    submitOffer: 'تقديم عرض',
    submittingOffer: 'جارٍ الإرسال...',
    submitOfferBtn: 'تقديم العرض',
    service: 'الخدمة',
    quantity: 'العدد',
    unitPrice: 'سعر الوحدة / لكل ساعة',
    total: 'المجموع',
    grandTotal: 'الإجمالي ({{days}} يوم × {{hours}} ساعة)',
    platformFees:
      'سيتم إضافة ١٠٪ رسوم استخدام المنصة و ١٥٪ ضريبة القيمة المضافة',
    additionalNotes: 'ملاحظات اضافية',
    optional: '(اختياري)',
    charCount: '{{count}}/1000 حرف',
    bankGuaranteeAck:
      'أقر بأنني في حال تم اختياري، سأكون ملزماً بتقديم ضمان بنكي بنسبة {{percent}}% خلال ١٠ أيام',
    successTitle: 'تم إرسال العرض بنجاح!',
    successMessage:
      'ستتلقى تنبيهًا عند ورود قبول من الجهة الطالبة للخدمة عبر نظام الإشعارات.',
    goToDashboard: 'الذهاب إلى لوحة التحكم',
    viewOtherRequests: 'اطلع على الطلبات الأخرى',
    backToOffers: 'العودة للعروض',
  },
  documents: {
    uploadRequired: 'رفع المستندات المطلوبة',
    uploadedCount: 'المستندات المرفوعة: {{uploaded}} من {{total}}',
    uploadComplete: 'اكتمل الرفع',
    remaining: '{{count}} متبقي',
    errorLoading: 'حدث خطأ أثناء تحميل البيانات',
    allUploaded: 'تم رفع جميع المستندات',
    allUploadedMessage:
      'المستندات الآن في انتظار مراجعة الفريق. سيتم إشعارك عند الموافقة أو في حال وجود ملاحظات.',
    approved: 'تمت الموافقة',
    underReview: 'قيد المراجعة',
    rejected: 'مرفوض',
    rejectionReason: 'سبب الرفض',
    documentUploaded: 'تم رفع المستند',
  },
  contract: {
    contractStatus: 'حالة العقد',
    downloading: 'جاري التحميل...',
    signatureStatus: 'حالة التوقيع',
    vendorSignature: 'توقيع المورّد',
    signed: 'تم التوقيع',
    awaitingSignature: 'في انتظار التوقيع',
    customerSignature: 'توقيع العميل',
    contractSigned: 'تم توقيع العقد بنجاح',
    contractSignedMessage:
      'تم توقيع العقد من قبل الطرفين. العقد الآن ساري المفعول.',
    awaitPayment: 'يرجى انتظار تأكيد الدفع من العميل قبل',
    awaitingCustomerSignature: 'في انتظار توقيع العميل',
    awaitingCustomerMessage:
      'تم توقيع العقد من جهتك بنجاح. نحن في انتظار توقيع العميل لإتمام العملية.',
    vendorTransfer: 'حوالة المورّد (10%)',
    statusLabel: 'الحالة:',
    viewTransfer: 'عرض الحوالة',
    approve: 'موافقة',
    reject: 'رفض',
    approving: 'جاري الموافقة...',
    uploading: 'جاري الرفع...',
    submitRejection: 'إرسال الرفض',
    submitting: 'جاري الإرسال...',
    transferApproved: 'تمت الموافقة على الحوالة بنجاح',
  },
  forgotPassword: {
    title: 'هل نسيت كلمة المرور؟',
    subtitle: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور.',
    emailSentTitle: 'تمت العملية بنجاح',
    emailSentMessage:
      'لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
    setNewPassword: 'ضبط كلمة مرور جديدة',
    setNewPasswordSubtitle: 'يرجى إدخال كلمة المرور الجديدة لتحديث حسابك.',
    newPassword: 'كلمة المرور الجديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    passwordChanged:
      'تم تغيير كلمة المرور بنجاح، جاري تحويلك إلى صفحة تسجيل الدخول...',
    passwordChangedTitle: 'تم تغيير كلمة المرور بنجاح!',
    useNewPassword: 'يمكنك استخدام كلمة المرور الجديدة.',
    errorOccurred: 'حدث خطأ',
    invalidCode: 'رمز التحقق غير صالح أو منتهي الصلاحية',
    backToRecovery: 'العودة إلى استعادة كلمة المرور',
    errorChangingPassword: 'حدث خطأ أثناء تغيير كلمة المرور',
  },
  validation: {
    emailRequired: 'البريد الإلكتروني مطلوب',
    emailInvalid: 'البريد الإلكتروني غير صحيح',
    passwordRequired: 'كلمة المرور مطلوبة',
    passwordMin8: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
    confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
    passwordsMismatch: 'كلمتا المرور غير متطابقتين',
    serviceProviderNameRequired: 'اسم مقدم الخدمة مطلوب',
    phoneRequired: 'مطلوب رقم الجوال',
    firstNameRequired: 'الاسم الاول مطلوب',
    lastNameRequired: 'اسم الاخير مطلوب',
    jobTitleRequired: 'المسمى الوظيفي مطلوب',
    contactNameRequired: 'اسم جهة الاتصال مطلوب',
    contactLastNameRequired: 'اسم العائلة لجهة الاتصال مطلوب',
    fileSizeLimit: 'يجب أن يكون حجم كل ملف 10 ميغابايت أو أقل.',
    pricePositive: 'السعر يجب أن يكون أكبر من صفر',
    allPricesRequired: 'يجب إدخال سعر صحيح لجميع الخدمات',
    bankGuaranteeRequired: 'يجب الموافقة على شروط الضمان البنكي للمتابعة',
    nameRequired: 'الاسم مطلوب',
    rejectionReasonRequired: 'سبب الرفض مطلوب',
  },
  errors: {
    resetLinkNotFound: 'لم يتم العثور على رابط إعادة تعيين كلمة المرور',
    verificationCodeNotFound: 'لم يتم العثور على رمز التحقق في الرابط',
    verificationCodeInvalid: 'رمز التحقق غير صالح أو منتهي الصلاحية',
    unauthorized: 'You are not authorized to perform this action',
  },
} as const;

export default ar;
